import { map, filter } from "lodash";
import type { RootState } from "types/state";

export const getPeriodState = (state: RootState) => {
  const periodState: unknown[] = map(
    state.employer.currentPayrolls,
    "periodState"
  );
  return periodState;
};

//Late Payrolls
export const latePayrolls = (state: RootState) => {
  const periodState = getPeriodState(state);
  return filter(periodState, (key) => key === "MISSED");
};
